// extracted by mini-css-extract-plugin
export default {"leftNav":"Menu_leftNav__kLeIh","verticalNavigation":"Menu_verticalNavigation__RXVZ9","glyphicon":"Menu_glyphicon__qIHLu","leftglyph":"Menu_leftglyph__PEDW4"};